import { Controller } from "@hotwired/stimulus"

export default class InputValidatorController extends Controller {
  static outlets = ["element-enabler"]
  static targets = ["firstElement", "secondElement"]

  assertLessThanOrEqualTo() {
    const firstValue = this.firstElementTarget.value
    const secondValue = this.secondElementTarget.value

    const valuesAreNotEmpty = firstValue && secondValue

    this.#updateElementState(
      valuesAreNotEmpty && Number(firstValue) <= Number(secondValue)
    )
  }

  assertLessThanOrEqualAllowingEmpty() {
    const firstValue = this.firstElementTarget.value.trim()
    const secondValue = this.secondElementTarget.value.trim()

    const isValid =
      !firstValue || !secondValue || Number(firstValue) <= Number(secondValue)

    this.#updateElementState(isValid)
  }

  #updateElementState(assertionResult) {
    if (assertionResult) {
      this.elementEnablerOutlet.enable()
    } else {
      this.elementEnablerOutlet.disable()
    }
  }
}
